export default __webpack_public_path__ + "static/media/GE.c8f18e9a.png";